module.exports = __webpack_public_path__ + "img/XTZ-alt.84b9670d.svg";